import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";

// Import Components
import LoadTop from "./components/LoadTop";
import BackTop from "./components/BackTop";
import CurrentLink from "./components/CurrentLink";
import Preloader from "./components/Preloader";
import Layout from "./components/Layout";

// Import Pages
import Home from "./home/HomeEight";
import HomeTwo from "./home/HomeTwo";
import HomeThree from "./home/HomeThree";
import HomeFour from "./home/HomeFour";
import HomeFive from "./home/HomeFive";
import HomeSix from "./home/HomeSix";
import HomeSeven from "./home/HomeSeven";
import HomeEight from "./home/Home";
import { SignUp } from "./components/SignUp";

import About from "./inner/About";
import Service from "./inner/Service";
import ServiceDetails from "./inner/ServiceDetails";
import Blog from "./inner/Blog";
import BlogColOne from "./inner/BlogColOne";
import BlogColTwo from "./inner/BlogColTwo";
import BlogDetails from "./inner/BlogDetails";
import BlogDetailsTwo from "./inner/BlogDetailsTwo";
import Appoinment from "./inner/Appoinment";
import ProjectMesonary from "./inner/ProjectMesonary";
import ProjectMesonaryThree from "./inner/ProjectMesonaryThree";
import Project from "./inner/Project";
import ProjectSlider from "./inner/ProjectSlider";
import ProjectDetails from "./inner/ProjectDetails";
import ProjectDetailsTwo from "./inner/ProjectDetailsTwo";
import TeamOne from "./inner/TeamOne";
import TeamTwo from "./inner/TeamTwo";
import TeamDetails from "./inner/TeamDetails";
import Pricing from "./inner/Pricing";
import FaqOne from "./inner/FaqOne";
import Error from "./inner/Error";
import Contact from "./inner/Contact";
import Login from "./components/Login";
import Gallery from "./elements/Gallery";
// import PrivacyPolicy from "./inner/privacypolicy";
import PrivacyPolicy from "./inner/Privacypolicy";
import VerificationPage from "./components/VerificationPage";
import SupportPage from "./inner/SupportPage";
import Events from "./elements/Events";
import Leads from "./inner/Leads";
import VisitorVerificationPage from "./components/VisitorVerificationPage";
import Termsconditions from "./inner/Termsconditions";
import Cancellationrefund from "./inner/Cancellationrefund";
import Shippingexchange from "./inner/Shippingexchange";

function App() {
  const RedirectToLogin = () => {
    useEffect(() => {
      window.location.replace("https://app.v2vbn.org/login");
    }, []);

    return null;
  };

  return (
    <div className="App">
      <Router>
        <LoadTop />
        <CurrentLink />
        <BackTop />
        <Preloader />

        <Routes>
          <Route path="/login" element={<RedirectToLogin />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/verify-email" element={<VerificationPage />} />
          <Route path="/verify-visitor-email" element={<VisitorVerificationPage />} />
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/home-two" element={<HomeTwo />} />
                  <Route path="/home-three" element={<HomeThree />} />
                  <Route path="/home-four" element={<HomeFour />} />
                  <Route path="/home-five" element={<HomeFive />} />
                  <Route path="/home-six" element={<HomeSix />} />
                  <Route path="/home-seven" element={<HomeSeven />} />
                  <Route path="/home-eight" element={<HomeEight />} />
                  <Route path="/About" element={<About />} />
                  <Route path="/Service" element={<Service />} />
                  <Route path="/ServiceDetails" element={<ServiceDetails />} />
                  <Route path="/Blog" element={<Blog />} />
                  <Route path="/BlogColOne" element={<BlogColOne />} />
                  <Route path="/BlogColTwo" element={<BlogColTwo />} />
                  <Route path="/BlogDetails" element={<BlogDetails />} />
                  <Route path="/BlogDetailsTwo" element={<BlogDetailsTwo />} />
                  <Route path="/Appoinment" element={<Appoinment />} />
                  <Route path="/Project" element={<Project />} />
                  <Route
                    path="/ProjectMesonary"
                    element={<ProjectMesonary />}
                  />
                  <Route
                    path="/ProjectMesonaryThree"
                    element={<ProjectMesonaryThree />}
                  />
                  <Route path="/ProjectSlider" element={<ProjectSlider />} />
                  <Route path="/ProjectDetails" element={<ProjectDetails />} />
                  <Route
                    path="/ProjectDetailsTwo"
                    element={<ProjectDetailsTwo />}
                  />
                  <Route path="/TeamOne" element={<TeamOne />} />
                  <Route path="/TeamTwo" element={<TeamTwo />} />
                  <Route path="/TeamDetails" element={<TeamDetails />} />
                  <Route path="/Pricing" element={<Pricing />} />
                  <Route path="/FaqOne" element={<FaqOne />} />
                  <Route path="/Error" element={<Error />} />
                  <Route path="/Contact-us" element={<Contact />} />
                  <Route path="/support" element={<SupportPage />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                  <Route path="/terms-conditions" element={<Termsconditions />} />
                  <Route path="/cancellation-refund" element={<Cancellationrefund />} />
                  <Route path="/shipping-exchange" element={<Shippingexchange />} />
                  <Route path="/visitors" element={<Leads />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
